<p-dialog [(visible)]="visible" [modal]="true" [closable]="true" [draggable]="false" [resizable]="false"
  [style]="{ width: '32rem' }" styleClass="intake-result-dialog">
  <div class="success-state">

    <img src="assets/images/success-illustration.png" alt="" style="height: 80px;" />

    <h2 class="success-title">Property Request Submitted Successfully!</h2>
    <p class="success-copy">
      Thank you for submitting your property request. Our Kore team is now reviewing your property details to
      determine its initial ADU feasibility. You can expect to receive your feasibility report via email within
      48-72 hours. If your property qualifies, we'll invite you to schedule a consultation to discuss the next steps.
    </p>
    <div class="success-actions">
      <button pButton type="button" label="Contact Kore" (click)="contactKore.emit()"></button>
      <button pButton type="button" label="Back to Home" class="p-button-outlined" (click)="backToHome.emit()"></button>
    </div>
  </div>
</p-dialog>
